import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=041e2daa&"
import script from "./Certificado.vue?vue&type=script&lang=js&"
export * from "./Certificado.vue?vue&type=script&lang=js&"
import style0 from "./Certificado.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports